function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#6ec7ef;}.cls-3{fill:#5d5d6d;}.cls-4{fill:#6c6c7a;}.cls-5{fill:#41404f;}.cls-6{fill:#6ed5ef;}.cls-7{fill:#6ea7ef;}.cls-8{fill:#e6e7e8;}.cls-9{fill:#565668;}.cls-10{fill:#878796;}.cls-11,.cls-34{fill:#ec983b;}.cls-12{fill:#2b3990;opacity:0.2;mix-blend-mode:multiply;}.cls-13{fill:#363142;}.cls-14{fill:#a55932;}.cls-15{fill:#f7ca82;}.cls-16{fill:#d1d3d4;}.cls-17{fill:#f7b378;}.cls-18{fill:#f1f2f2;}.cls-19{fill:#1c75bc;}.cls-20{fill:#b64d50;}.cls-21{fill:#9d5932;}.cls-22{fill:#c49a6c;}.cls-23{fill:#8e4d50;}.cls-24{fill:#ef4661;}.cls-25{fill:#ef5f61;}.cls-26{fill:#fba140;}.cls-27{fill:#f9dc32;}.cls-28{fill:#ffe252;}.cls-29{fill:#414042;}.cls-30{fill:#00a79d;}.cls-31{fill:#10c1b0;}.cls-32{fill:#585866;}.cls-33{fill:#bcbec0;}.cls-34{mix-blend-mode:overlay;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "OBJECTS"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "380.98 73 380.98 128.06 295.87 78.82 295.87 23.77 380.98 73"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M382.44,165.46l-18.83,12-8.39,7.75L34.66,254.14l-5.36-4.92-23.75-5v18.43h0a3,3,0,0,0,1.53,2.75l3.81,2.2,116.18,67.21h0a5.64,5.64,0,0,0,5.62,0L372.18,196.55l14.61-8.43a5.42,5.42,0,0,0,2.73-4.93h0V164.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M389.52,183.19h0V164.75l-7.08.71-18.83,12-8.39,7.75L249.89,207.89,130.71,310.83v24.66a5.49,5.49,0,0,0,2-.68L372.18,196.55l14.61-8.43A5.42,5.42,0,0,0,389.52,183.19Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "20.23 260.28 20.23 267.38 13.69 263.61 13.69 256.5 20.23 260.28"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "29.13 265.39 29.13 272.5 22.6 268.73 22.6 261.62 29.13 265.39"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "38.04 270.51 38.04 277.62 31.51 273.84 31.51 266.74 38.04 270.51"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "121.22 318.93 121.22 326.03 100.89 314.25 100.89 307.15 121.22 318.93"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "160.11 306.26 160.11 313.37 180.43 301.59 180.43 294.49 160.11 306.26"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "33.79 232.72 253.19 106.03 369.36 173.24 149.96 299.92 33.79 232.72"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "253.19 106.03 149.96 299.92 33.79 232.72 253.19 106.03"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "360.32 178.46 369.36 173.24 253.19 106.03 244.15 111.25 360.32 178.46"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "149.97 299.92 159.01 294.7 42.83 227.5 33.79 232.72 149.97 299.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "366.69 173.18 363.1 171.1 356.88 174.69 360.47 176.77 366.69 173.18"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "362.29 170.64 358.71 168.56 352.49 172.16 356.08 174.23 362.29 170.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "357.9 168.1 354.31 166.03 348.09 169.62 351.68 171.69 357.9 168.1"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "353.5 165.56 349.92 163.49 343.7 167.08 347.29 169.15 353.5 165.56"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "314.43 143.08 304.22 137.14 298 140.73 308.21 146.67 314.43 143.08"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "155.65 294.29 145.45 288.36 139.23 291.95 149.43 297.88 155.65 294.29"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "101.53 263.05 91.33 257.11 85.11 260.7 95.31 266.64 101.53 263.05"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "53.55 235.23 43.35 229.29 37.13 232.89 47.33 238.82 53.55 235.23"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M386.79,160.2l-.21-.13L270.41,92.87h0a5.61,5.61,0,0,0-5.63,0L31,227.85,7.09,241.63a3.07,3.07,0,0,0,0,5.33l3.81,2.21,116.18,67.2h0a5.59,5.59,0,0,0,5.62,0L372.18,178.11l14.61-8.43A5.47,5.47,0,0,0,386.79,160.2ZM150,299.92,33.79,232.72,253.19,106l116.17,67.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M361.09,198l0,0a.36.36,0,0,1-.09-.08h0l-.1-.11,0,0-.06-.08,0,0a.36.36,0,0,1-.07-.1s0,0,0,0a1,1,0,0,1-.08-.14l-.08-.15v0a.61.61,0,0,1-.05-.12s0,0,0,0a.41.41,0,0,0,0-.08.56.56,0,0,0,0-.12.19.19,0,0,0,0-.08l0-.11s0-.07,0-.1,0-.06,0-.09,0-.07,0-.11,0-.06,0-.09a.52.52,0,0,0,0-.11v-.09s0-.09,0-.14,0,0,0-.06v-.5c0-.05,0-.1,0-.15v-.08a.88.88,0,0,1,0-.16v-.06l0-.23v0l0-.19a.31.31,0,0,0,0-.08l0-.15a.29.29,0,0,0,0-.09c0-.05,0-.1,0-.15s0-.06,0-.08,0-.11,0-.16a.14.14,0,0,1,0-.07c0-.08,0-.16.07-.23v0a1.72,1.72,0,0,1,.07-.21l0-.07.06-.16,0-.07c0-.06.05-.11.07-.17a.42.42,0,0,0,0-.06c0-.07.07-.14.1-.22l0,0,.08-.17.06-.12.06-.11.17-.3.06-.11.08-.12.07-.11.07-.12.06-.07a3.62,3.62,0,0,1,.22-.32h0l.17-.22.13-.16,0,0c0-.06.1-.13.16-.19a.12.12,0,0,1,.05-.05l.12-.13.06-.07a1.14,1.14,0,0,1,.11-.11.46.46,0,0,1,.07-.07.94.94,0,0,1,.1-.1l.08-.08.1-.09.09-.07.1-.09.08-.06.11-.09.07-.06.13-.09.06,0,.18-.12h0l.19-.12.17-.09.07,0,.13-.06.06,0,.18-.07.18-.07.05,0,.12,0,.08,0,.1,0,.07,0,.1,0h.77l.14,0h0l.11,0,0,0,.09,0,.11,0,0,0,.14.08L365,187.44l-.15-.07-.05,0a2.56,2.56,0,0,0-1.77,0,5.2,5.2,0,0,0-1.56.87l-.05,0-.08.06a8.66,8.66,0,0,0-3.07,5.82,3.79,3.79,0,0,0,.44,2.29h0s0,0,0,0a.61.61,0,0,1,.07.1l0,0,.07.08,0,0,.09.1,0,0,.09.08,0,0,.08.06,0,0,.12.08,1.89,1.1-.12-.08,0,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M364.11,188.82a8.71,8.71,0,0,0-3.94,6.83c0,2.51,1.78,3.53,4,2.26a8.72,8.72,0,0,0,3.94-6.83C368.07,188.57,366.3,187.56,364.11,188.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M340.66,209.83l0,0-.09-.08v0a.94.94,0,0,1-.1-.1l0,0-.06-.08,0,0a.36.36,0,0,1-.07-.1l0,0a.57.57,0,0,1-.08-.13l-.08-.15s0,0,0,0a1.12,1.12,0,0,1-.05-.13l0,0s0,0,0-.08l-.05-.12a.29.29,0,0,0,0-.09l0-.1s0-.06,0-.1,0-.06,0-.09,0-.08,0-.11,0-.06,0-.09,0-.08,0-.12v-.08a.61.61,0,0,1,0-.14.13.13,0,0,1,0-.06v-.5a.81.81,0,0,0,0-.16.17.17,0,0,0,0-.07.88.88,0,0,1,0-.16v-.06l0-.23a0,0,0,0,0,0,0l0-.2a.19.19,0,0,0,0-.07l0-.15a.29.29,0,0,0,0-.09s0-.1,0-.15a.31.31,0,0,0,0-.08c0-.06,0-.11,0-.16a.24.24,0,0,1,0-.08l.07-.22v0c0-.07.05-.14.07-.21l0-.07.06-.16,0-.07a1.22,1.22,0,0,1,.07-.17s0,0,0-.06a1.47,1.47,0,0,0,.1-.22l0-.05.08-.17.06-.12.06-.11.17-.31.06-.1.08-.12.07-.11.07-.12.06-.08.22-.32h0l.17-.22.13-.16,0,0c.05-.07.11-.13.16-.19L342,202l.11-.12.07-.08a.94.94,0,0,0,.1-.1.6.6,0,0,0,.08-.08l.1-.09a.6.6,0,0,1,.08-.08l.1-.09.08-.07.11-.09.08-.06.11-.09.07-.06.13-.09.06,0a1.22,1.22,0,0,1,.19-.12h0l.19-.12.17-.09.07,0,.13-.06.05,0,.19-.08.18-.06,0,0,.13,0,.06,0,.11,0h.07l.11,0h.76l.14,0h0l.11,0h.05l.09,0,.11,0,.05,0,.14.07-1.89-1.1-.15-.07-.05,0a2.62,2.62,0,0,0-1.77,0,5.2,5.2,0,0,0-1.56.87l-.05,0a.27.27,0,0,1-.08.07,8.74,8.74,0,0,0-3.08,5.82,3.87,3.87,0,0,0,.45,2.29h0l0,0a.61.61,0,0,1,.07.1l0,0,.07.08,0,0,.1.1,0,0,.09.08,0,0,.09.07,0,0,.12.08,1.89,1.1-.12-.08,0,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M343.68,200.62a8.66,8.66,0,0,0-3.94,6.83c0,2.51,1.78,3.52,4,2.26a8.68,8.68,0,0,0,3.95-6.83C347.64,200.37,345.86,199.36,343.68,200.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M383.54,63.55,299.66,15A1.7,1.7,0,0,0,298,15h0l-3.21,1.86,2.36,8.45V80.88a5.66,5.66,0,0,0,2.83,4.9l80.82,46.76.94,2.54,3.23-1.88h0a3,3,0,0,0,1.57-2.68V68.65A5.91,5.91,0,0,0,383.54,63.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M383.25,70.53V132.4a3.08,3.08,0,0,1-4.62,2.67L296.7,87.66a5.65,5.65,0,0,1-2.84-4.91V18.39a1.72,1.72,0,0,1,2.57-1.49l83.88,48.53A5.9,5.9,0,0,1,383.25,70.53Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-11",
  points: "380.98 73 380.98 128.06 295.87 78.82 295.87 23.77 380.98 73"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "317.65 43.64 317.65 41.63 299.62 31.2 299.62 33.21 317.65 43.64"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "317.65 47.49 317.65 45.48 299.62 35.05 299.62 37.06 317.65 47.49"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "317.65 51.35 317.65 49.34 299.62 38.91 299.62 40.92 317.65 51.35"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "327.76 47.58 327.76 49.58 345.8 60.02 345.8 58.01 327.76 47.58"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "327.76 53.44 345.8 63.87 345.8 61.86 327.76 51.43 327.76 53.44"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "327.76 57.3 345.8 67.73 345.8 65.72 327.76 55.29 327.76 57.3"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "327.76 66.96 345.8 77.39 345.8 75.38 327.76 64.95 327.76 66.96"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "327.76 70.82 345.8 81.25 345.8 79.24 327.76 68.81 327.76 70.82"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "327.76 74.67 345.8 85.1 345.8 83.09 327.76 72.66 327.76 74.67"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "327.76 84.34 345.8 94.77 345.8 92.76 327.76 82.33 327.76 84.34"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "327.76 88.19 345.8 98.63 345.8 96.62 327.76 86.19 327.76 88.19"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "327.76 92.05 345.8 102.48 345.8 100.47 327.76 90.04 327.76 92.05"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "317.65 55.21 317.65 53.2 299.62 42.77 299.62 44.77 317.65 55.21"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "359.23 89.14 352.85 85.45 352.85 106.32 359.23 110.01 359.23 89.14"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "367.66 82.71 361.28 79.02 361.28 111.21 367.66 114.89 367.66 82.71"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "376.08 76.32 369.71 72.63 369.71 116.09 376.08 119.78 376.08 76.32"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M310.27,69.32V57.64l-.6-.38c-5.53-3.19-10-.63-10.05,5.73s4.45,14.11,10,17.3,10,.63,10.06-5.73c0-.09,0-.19,0-.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M328.36,181l-16.1-9.36a5.63,5.63,0,0,0-5.64,0l-16.81,9.7a3.69,3.69,0,0,0,0,6.37L305,196.51a6.74,6.74,0,0,0,6.71,0l16.68-9.63a3.41,3.41,0,0,0,0-5.9Zm-1,4.12-16.68,9.64a4.63,4.63,0,0,1-4.64,0l-15.17-8.82a1.63,1.63,0,0,1,0-2.82l16.81-9.71a3.55,3.55,0,0,1,3.58,0l16.1,9.36a1.32,1.32,0,0,1,.67,1.18A1.3,1.3,0,0,1,327.32,185.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M291.81,161.79a3.39,3.39,0,0,0-1.7-2.95L274,149.47a5.63,5.63,0,0,0-5.64,0l-16.81,9.71a3.67,3.67,0,0,0,0,6.36l15.16,8.82a6.65,6.65,0,0,0,6.7,0l16.68-9.63A3.37,3.37,0,0,0,291.81,161.79ZM289.08,163l-16.69,9.63a4.61,4.61,0,0,1-4.64,0l-15.16-8.82a1.63,1.63,0,0,1,0-2.82l16.81-9.71a3.65,3.65,0,0,1,1.79-.47,3.56,3.56,0,0,1,1.79.48l16.1,9.37a1.36,1.36,0,0,1,0,2.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M253.56,139.63a3.37,3.37,0,0,0-1.7-2.95l-16.09-9.37a5.65,5.65,0,0,0-5.64,0L213.32,137a3.68,3.68,0,0,0,0,6.37l15.16,8.82a6.72,6.72,0,0,0,6.7,0l16.68-9.64A3.35,3.35,0,0,0,253.56,139.63Zm-2.73,1.17-16.68,9.63a4.65,4.65,0,0,1-4.65,0l-15.16-8.83a1.6,1.6,0,0,1-.81-1.41,1.63,1.63,0,0,1,.81-1.41l16.81-9.7a3.56,3.56,0,0,1,1.79-.48,3.62,3.62,0,0,1,1.8.48l16.09,9.37a1.36,1.36,0,0,1,0,2.35Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "110.31 49.24 110.31 104.29 195.42 55.05 195.42 0 110.31 49.24"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "0 140.93 0 195.98 85.11 146.74 85.11 91.69 0 140.93"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M344.66,162.25a2.44,2.44,0,0,0-.16-.78,4,4,0,0,0-.19-.48,4.49,4.49,0,0,0-.65-.9A6,6,0,0,0,342.3,159a9.68,9.68,0,0,0-2.19-.89,12.59,12.59,0,0,0-2.67-.42l-.72,0c-.23,0-.47,0-.7,0a1.18,1.18,0,0,0-.54.17c-.1.06-.24.18-.24.31a.41.41,0,0,0,.24.35,2.21,2.21,0,0,0,1.17.13,9.08,9.08,0,0,1,4.52,1.07,3.22,3.22,0,0,1,1.84,2.43l0,.35a.41.41,0,0,0,.25.35,1.18,1.18,0,0,0,.6.14,1.21,1.21,0,0,0,.62-.18A.6.6,0,0,0,344.66,162.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M341.62,162.18a2,2,0,0,0-.42-1.07,3.19,3.19,0,0,0-1-.82,6.75,6.75,0,0,0-3.3-.78,4.49,4.49,0,0,0-1.1,0c-.23.06-.54.2-.54.47a.46.46,0,0,0,.27.37,1.47,1.47,0,0,0,.65.17l.69,0A4.22,4.22,0,0,1,339,161a1.93,1.93,0,0,1,.71.65,1.38,1.38,0,0,1,.15.4c0,.17-.06.35,0,.52a.46.46,0,0,0,.24.27c.48.28,1.47.27,1.56-.43A1.22,1.22,0,0,0,341.62,162.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M337.75,161.67a2.22,2.22,0,0,0-2.05,0c-.56.33-.6.86,0,1.21a2.28,2.28,0,0,0,2.05,0A.62.62,0,0,0,337.75,161.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M180.19,270.12l-22.34-12.89a2.1,2.1,0,0,0-2.11,0L133.55,270a2.12,2.12,0,0,0,0,3.67l22.34,12.89a2.1,2.1,0,0,0,2.11,0l22.2-12.77A2.12,2.12,0,0,0,180.19,270.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M106.34,225.73,84,212.84a2.1,2.1,0,0,0-2.11,0L59.7,225.61a2.11,2.11,0,0,0,0,3.66L82,242.16a2.1,2.1,0,0,0,2.11,0l22.2-12.77A2.11,2.11,0,0,0,106.34,225.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M152.49,198.83l-22.34-12.89a2.1,2.1,0,0,0-2.11,0l-22.19,12.77a2.11,2.11,0,0,0,0,3.66l22.34,12.9a2.14,2.14,0,0,0,2.11,0l22.19-12.78A2.11,2.11,0,0,0,152.49,198.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M193.59,174.91,171.26,162a2.16,2.16,0,0,0-2.12,0L147,174.79a2.12,2.12,0,0,0,0,3.67l22.33,12.89a2.14,2.14,0,0,0,2.12,0l22.19-12.77A2.12,2.12,0,0,0,193.59,174.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M226.7,242.55l-22.34-12.89a2.14,2.14,0,0,0-2.11,0l-22.19,12.77a2.12,2.12,0,0,0,0,3.67L202.39,259a2.1,2.1,0,0,0,2.11,0l22.2-12.77A2.12,2.12,0,0,0,226.7,242.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M268.54,218.62l-22.33-12.89a2.1,2.1,0,0,0-2.11,0L221.9,218.5a2.12,2.12,0,0,0,0,3.67l22.33,12.89a2.14,2.14,0,0,0,2.12,0l22.19-12.77A2.12,2.12,0,0,0,268.54,218.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M180.67,164.38a7.79,7.79,0,0,0,3.51-.72c1.13-.76,3.77,2.42,1.17,4.1s-5.3,3.36-6.7,3.12-2.17-.48-2.29-.8-.16-5.94-.16-5.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M181.66,160.15v6.41s-3.62,1.58-6,.66l-.9-4.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M190.93,168.06a7.79,7.79,0,0,0,3.51-.72c1.12-.76,3.77,2.42,1.16,4.1s-5.29,3.36-6.7,3.12-2.16-.48-2.28-.8-.16-5.94-.16-5.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M190.38,140.19a30.78,30.78,0,0,1,1.79-2.77c.79-1,1.86-2.67.87-3.51s-2.85-1.84-3.74-1.78-2.32,1.22-1.83,1.79-.42,3.37-.42,3.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M156.4,121.91a3.59,3.59,0,0,1,3.72-1l2.79.83,7.62,3.55L175.8,128l.45,16.87.54,8.23-3.13,2.65c-3.73,3.49-15.16-2.65-15.16-2.65-1.93-6.38-4.76-23.95-4.76-23.95A11.11,11.11,0,0,1,156.4,121.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M175.52,148.81s8-1.69,12.88-2.12a3.13,3.13,0,0,1,3.42,3,153.36,153.36,0,0,1-.17,19.61l-3,1.85a2.08,2.08,0,0,1-3.18-1.66l-.55-10.9c0-.93-1.15.2-1.86.81-2.23,1.91-7.59,4.06-10.85,2.92,0,0-9.79-3-12.14-9.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M170.74,164.39,173.5,163l-1.58,24.31a1.49,1.49,0,0,1-.47,1,2.15,2.15,0,0,1-1,.51c-.7.11-1.29-.63-1.23-1.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M150.81,154.18l2.69-1.43-1.79,22.39a1.57,1.57,0,0,1-.48,1.05,2,2,0,0,1-.8.46c-.75.22-1.44-.61-1.36-1.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M187.71,159.06l3.2,19.49a1.36,1.36,0,0,1-.32,1.18,1.51,1.51,0,0,1-.59.34c-.44.12-.86-.26-1-.84L185.15,160Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M165.48,107.13c1.82-.29,2.85-.64,4.61-.12,3,.87,4.54,3.68,5.25,6.49s.94,7-.68,9.59c-1,1.65-3.28,1.34-4.89.91a19.27,19.27,0,0,1-6.1-2.56c-2.22-1.69-3.4-5.37-3.54-8C160,111.11,162.7,107.59,165.48,107.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M162.91,120.74a5.45,5.45,0,0,0,.76.69,19.07,19.07,0,0,0,6.1,2.57c.31.08.65.16,1,.22l-.23,1.06a15.53,15.53,0,0,1-5.67.34,2.22,2.22,0,0,1-2-2.2v-2.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M173,127.57s4.39-.13,5.47,2.94,3.55,9.21,3.55,9.21,3.73-2.89,5.12-3.25c0,0,3.07,1.57,3.79,3.25,0,0-4.63,8-10.29,10.35a39.66,39.66,0,0,1-9.11-14S167.88,130,173,127.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M151.85,130.14c11.51,2.39,17.35,8.53,19.19,10.84a3,3,0,0,1,.65,1.9V165c-15.4-2.56-22-11.63-22-11.63V131.88A1.78,1.78,0,0,1,151.85,130.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M171.69,165s13.28-1.32,17.37-5.91c0,0,.3-3.09-1-2.67s-7.26,4.09-16.41,5.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-20",
  d: "M174.43,108.51l2-.86a15.63,15.63,0,0,0-11-1,5.44,5.44,0,0,0-1.46.47c-2,1-4,3.94-3.85,6.24.14,2.66,1.32,6.34,3.54,8a16.18,16.18,0,0,0,4.67,2.16c.46-.22,1.14-2.7,1.14-2.7-.93-.55-1.65-3.64-.66-4.19s1.65,1.39,1.65,1.39a1.48,1.48,0,0,0,1-2,2.88,2.88,0,0,1-.22-1.11,1.29,1.29,0,0,1,1.19-1.26c.31,0,.59,0,.86-.09a29.3,29.3,0,0,1,4.92.14A17.88,17.88,0,0,0,174.43,108.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M255.37,208.11a7.84,7.84,0,0,0,3.52-.72c1.12-.77,3.77,2.41,1.16,4.09s-5.3,3.37-6.7,3.12-2.17-.48-2.29-.8-.16-5.93-.16-5.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M256.36,203.87v6.41s-3.61,1.59-6,.67l-.9-4.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M265.63,211.79a7.84,7.84,0,0,0,3.52-.72c1.12-.77,3.76,2.41,1.16,4.09s-5.3,3.37-6.7,3.12-2.17-.48-2.29-.8-.16-5.93-.16-5.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-22",
  d: "M231.45,166a3.9,3.9,0,0,1,3.82-1.21l2.34.7,7.62,3.55,5.28,2.77.45,16.86.53,8.23-3.13,2.65c-3.73,3.49-15.16-2.65-15.16-2.65-1.93-6.38-4-23.73-4-23.73C229.28,169.52,230.25,167.32,231.45,166Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M250.23,192.53s9.14-1.87,14-2.31a3.14,3.14,0,0,1,3.41,3c.21,4.43-.69,13.16-1.32,19.8l-3,1.85a2.08,2.08,0,0,1-3.18-1.66l-.54-10.89c-.05-.93-1.16.2-1.87.8-2.22,1.91-7.58,4.07-10.85,2.93,0,0-9.78-3-12.13-9.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M245.44,208.11l2.77-1.42L246.63,231a1.5,1.5,0,0,1-.48,1,2,2,0,0,1-1,.51c-.69.12-1.29-.62-1.23-1.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M225.52,197.9l2.69-1.42-1.79,22.38a1.51,1.51,0,0,1-.49,1,1.93,1.93,0,0,1-.79.46c-.76.22-1.45-.6-1.37-1.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M262.41,202.78l3.2,19.5a1.31,1.31,0,0,1-.32,1.17,1.34,1.34,0,0,1-.59.34c-.43.12-.86-.25-1-.83l-3.87-19.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M240.18,150.86c1.83-.3,2.86-.65,4.62-.13,3,.88,4.53,3.69,5.25,6.5s.93,7-.69,9.59c-1,1.64-3.27,1.33-4.89.91a19,19,0,0,1-6.09-2.57c-2.23-1.68-3.41-5.37-3.54-8C234.72,154.84,237.4,151.31,240.18,150.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M244.47,167.73a19,19,0,0,1-6.09-2.57,5,5,0,0,1-.76-.7h0v2.68a3.53,3.53,0,0,0,2.9,1.61c1.48.17,2.65.82,4.72.25l.24-1.06C245.12,167.88,244.79,167.81,244.47,167.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M226.56,173.86c11.5,2.4,17.34,8.54,19.18,10.84a3,3,0,0,1,.66,1.9v22.1c-15.41-2.57-22-11.64-22-11.64V175.61A1.8,1.8,0,0,1,226.56,173.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M246.4,208.7s13.28-1.33,17.37-5.92c0,0,.3-3.09-1-2.67s-7.27,4.09-16.41,5.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M237.45,165l-.59,1.79a8.26,8.26,0,0,0,9.38,2.76l-.85-1.06S239.9,168.62,237.45,165Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M264.85,188.1a8.72,8.72,0,0,1,1.85-.23c.68,0,1.14.88,1.69,1.19a3.4,3.4,0,0,1,1.49,2.58c0,1.19-.53,2.49-1.18,2.49s-.8.13-1-.36a23.46,23.46,0,0,0-1.35-2.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M265.45,187.42c-1.38.36-9.07.92-9.07.92s-.94-9.77-2-12.84a6.14,6.14,0,0,0-4-3.79c-5.12,2.47-2.45,8.85-2.45,8.85a77.65,77.65,0,0,1,3.36,12.49,2,2,0,0,0,2.28,1.62c6.81-1.1,13.22-2.66,13.22-2.66A8.7,8.7,0,0,0,265.45,187.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-23",
  d: "M249.91,152.05c-4.2-3.5-10-1.58-10-1.58h0a5.41,5.41,0,0,0-1.27.42c-2,1-4,4-3.84,6.24.13,2.66,1.31,6.35,3.54,8a15.9,15.9,0,0,0,4.67,2.15c.45-.21,1.13-2.7,1.13-2.7-.93-.54-1.65-3.64-.66-4.18s1.66,1.38,1.66,1.38a1.47,1.47,0,0,0,1-2,3.44,3.44,0,0,1,0-2.35c4.15-.11,4.68,1.36,4.68,1.36A6.28,6.28,0,0,0,249.91,152.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M139.07,188.3a7.79,7.79,0,0,0,3.51-.72c1.13-.76,3.77,2.41,1.17,4.09s-5.3,3.37-6.7,3.13-2.17-.48-2.29-.8-.16-5.94-.16-5.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M140.06,184.07v6.41s-3.62,1.58-6,.66l-.89-4.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M149.33,192a7.79,7.79,0,0,0,3.51-.72c1.12-.76,3.77,2.41,1.16,4.09s-5.29,3.37-6.69,3.13-2.17-.48-2.29-.8-.16-5.94-.16-5.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M114.8,145.82a3.63,3.63,0,0,1,3.72-1l2.79.83,7.62,3.55,5.28,2.77.45,16.86.53,8.24-3.13,2.64c-3.73,3.49-15.16-2.64-15.16-2.64-1.93-6.38-4.76-23.95-4.76-23.95A11.14,11.14,0,0,1,114.8,145.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M133.93,172.72s8-1.68,12.87-2.12a3.14,3.14,0,0,1,3.42,3,153.35,153.35,0,0,1-.17,19.61l-3,1.85a2.08,2.08,0,0,1-3.18-1.65l-.55-10.9c0-.93-1.15.2-1.86.8-2.23,1.92-7.59,4.07-10.85,2.93,0,0-9.79-3-12.14-9.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M129.14,188.31l2.76-1.43-1.58,24.3a1.45,1.45,0,0,1-.47,1,2,2,0,0,1-1,.52c-.7.11-1.29-.63-1.23-1.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M109.22,178.09l2.69-1.42-1.79,22.39a1.6,1.6,0,0,1-.49,1.05,2.22,2.22,0,0,1-.8.46c-.75.21-1.44-.61-1.36-1.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M146.11,183l3.2,19.5a1.25,1.25,0,0,1-.91,1.51c-.43.12-.86-.25-1-.83l-3.86-19.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M123.88,131.05c1.82-.3,2.86-.64,4.62-.12,3,.87,4.53,3.68,5.25,6.49s.93,7-.69,9.59c-1,1.64-3.27,1.34-4.89.91a19.07,19.07,0,0,1-6.1-2.57c-2.22-1.68-3.4-5.36-3.54-8C118.42,135,121.1,131.51,123.88,131.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M121.31,144.66a7,7,0,0,0,.76.69,19.07,19.07,0,0,0,6.1,2.57c.31.08.65.15,1,.21l-.24,1.06c-2.07.57-3.15.11-4.63-.06-1.11-.13-3-.67-3-1.79v-2.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M110.26,154.06c11.5,2.39,17.34,8.53,19.18,10.83a3.07,3.07,0,0,1,.66,1.91v22.09c-15.41-2.57-22-11.63-22-11.63V155.8A1.78,1.78,0,0,1,110.26,154.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M130.1,188.89s13.27-1.33,17.37-5.92c0,0,.3-3.08-1-2.66s-7.26,4.09-16.4,5.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M148.15,167.51a8.28,8.28,0,0,1,1.85-.22c.68.05,1.14.88,1.69,1.19a3.44,3.44,0,0,1,1.5,2.58c0,1.19-.54,2.49-1.19,2.49s-.8.13-1-.36a23.46,23.46,0,0,0-1.35-2.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M147.41,167.16l1.34-.28a10,10,0,0,1,1.16,4.27l-1.18.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-25",
  d: "M147.82,166.93c-1.39.37-9.08.93-9.08.93s-.93-9.78-2-12.85a6.17,6.17,0,0,0-4-3.79c-5.11,2.47-2.45,8.86-2.45,8.86a75.28,75.28,0,0,1,3.36,12.49,2,2,0,0,0,2.28,1.62c6.81-1.11,13.23-2.66,13.23-2.66A8.75,8.75,0,0,0,147.82,166.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-26",
  d: "M133.61,137s5.1-5.38,0-6.86-10-1.41-13.64.39-3.24,7.19-2.56,8.51a24.89,24.89,0,0,0,4.18,6,.67.67,0,0,0,.23.13l.25.21a16.3,16.3,0,0,0,4.67,2.16c.46-.22,1.14-2.71,1.14-2.71-.93-.54-1.65-3.64-.66-4.18s1.66,1.38,1.66,1.38a1.47,1.47,0,0,0,1-2,3.44,3.44,0,0,1,0-2.35A8.33,8.33,0,0,0,133.61,137Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M121.31,145.15l-.83,1.83a7.24,7.24,0,0,0,9.08,2.54l-.46-1.09S123.76,148.79,121.31,145.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M213.78,232a7.81,7.81,0,0,0,3.51-.72c1.12-.76,3.77,2.42,1.16,4.1s-5.3,3.36-6.7,3.12-2.17-.48-2.29-.8-.16-5.94-.16-5.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M214.77,227.79v6.41s-3.62,1.58-6,.67l-.9-4.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M224,235.7a7.84,7.84,0,0,0,3.52-.72c1.12-.76,3.77,2.41,1.16,4.1s-5.3,3.36-6.7,3.12-2.17-.48-2.29-.8-.16-5.94-.16-5.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M223.48,207.83a30.78,30.78,0,0,1,1.79-2.77c.8-1,1.87-2.67.88-3.51s-2.85-1.84-3.74-1.78-2.32,1.21-1.84,1.79-.41,3.37-.41,3.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-27",
  d: "M189.51,189.55a3.57,3.57,0,0,1,3.71-1l2.79.83,7.63,3.55,5.27,2.76.45,16.87.54,8.23-3.13,2.65c-3.74,3.49-15.17-2.65-15.17-2.65-1.92-6.38-4.75-23.95-4.75-23.95A11.11,11.11,0,0,1,189.51,189.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M208.63,216.45s8-1.69,12.88-2.12a3.12,3.12,0,0,1,3.41,3,153.14,153.14,0,0,1-.16,19.61l-3,1.85a2.08,2.08,0,0,1-3.18-1.66l-.54-10.9c-.05-.93-1.16.2-1.86.81-2.23,1.91-7.59,4.07-10.85,2.92,0,0-9.79-3-12.14-9.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M203.85,232l2.76-1.43L205,254.91a1.53,1.53,0,0,1-.47,1,2.15,2.15,0,0,1-1,.51c-.7.11-1.3-.63-1.24-1.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M183.92,221.82l2.69-1.42-1.79,22.38a1.57,1.57,0,0,1-.48,1.05,2,2,0,0,1-.8.46c-.75.22-1.45-.6-1.36-1.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M220.82,226.69l3.19,19.5a1.35,1.35,0,0,1-.31,1.18,1.54,1.54,0,0,1-.6.34c-.43.12-.86-.26-1-.84l-3.87-19.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M198.59,174.77c1.82-.29,2.85-.64,4.61-.12,3,.87,4.53,3.68,5.25,6.49s.93,7-.69,9.59c-1,1.65-3.27,1.34-4.88.91a19.07,19.07,0,0,1-6.1-2.57c-2.23-1.68-3.41-5.36-3.54-8C193.12,178.75,195.81,175.23,198.59,174.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M196,188.38a5.45,5.45,0,0,0,.76.69,19.07,19.07,0,0,0,6.1,2.57c.31.08.64.16,1,.22l-.23,1.06a15.55,15.55,0,0,1-5.67.34,2.22,2.22,0,0,1-2-2.2v-2.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-28",
  d: "M206.1,195.21s4.4-.13,5.48,2.94,3.55,9.21,3.55,9.21,3.73-2.89,5.11-3.25c0,0,3.07,1.57,3.79,3.25,0,0-4.63,8-10.28,10.35a39.54,39.54,0,0,1-9.11-14S201,197.67,206.1,195.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M185,197.78c11.51,2.39,17.34,8.53,19.18,10.84a3,3,0,0,1,.66,1.9v22.09c-15.41-2.56-22-11.63-22-11.63V199.52A1.78,1.78,0,0,1,185,197.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M204.8,232.61s13.28-1.32,17.37-5.92c0,0,.3-3.08-1-2.66s-7.27,4.09-16.41,5.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M208.31,180.69s3.26-2.83,1-4.36c-.71-.48-1.45-.53-2-1.22a6.75,6.75,0,0,0-2.09-2c-.79-.4-1.46.39-2.2.58-1.39.37-2.43-1.23-3.78-.86a4.85,4.85,0,0,0-1.23.74c-1.05.65-3.72.13-3.61,1.91a2.72,2.72,0,0,1-1.2,2.45,2.35,2.35,0,0,0-1.19,2.38,7,7,0,0,0,.56,1.13,4.81,4.81,0,0,1,.29,1.5,5.59,5.59,0,0,0,1.07,3.08,12.13,12.13,0,0,0,7.51,5.2c.45-.22,1.14-2.7,1.14-2.7-.94-.54-1.66-3.64-.67-4.19s1.66,1.39,1.66,1.39a1.48,1.48,0,0,0,1-2,3.41,3.41,0,0,1,0-2.34A8.62,8.62,0,0,0,208.31,180.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M92,215.87a7.79,7.79,0,0,0,3.51-.72c1.13-.76,3.78,2.41,1.17,4.09s-5.3,3.37-6.7,3.13-2.17-.48-2.29-.8-.16-5.94-.16-5.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M93,211.63V218s-3.62,1.59-6,.67l-.9-4.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-21",
  d: "M102.25,219.55a7.79,7.79,0,0,0,3.51-.72c1.13-.76,3.77,2.41,1.17,4.09s-5.3,3.37-6.7,3.13-2.17-.48-2.29-.81-.16-5.93-.16-5.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M101.7,191.67a29.74,29.74,0,0,1,1.79-2.76c.8-1,1.87-2.68.88-3.51s-2.85-1.84-3.75-1.79-2.31,1.22-1.83,1.79-.41,3.38-.41,3.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-30",
  d: "M67.72,173.39a3.63,3.63,0,0,1,3.72-1l2.79.83,7.62,3.55,5.28,2.77.45,16.86.53,8.23L85,207.27c-3.73,3.49-15.16-2.65-15.16-2.65-1.93-6.37-4.76-23.94-4.76-23.94A11.12,11.12,0,0,1,67.72,173.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M86.85,200.29s8-1.68,12.88-2.12a3.13,3.13,0,0,1,3.41,3,153.35,153.35,0,0,1-.17,19.61l-3,1.85a2.08,2.08,0,0,1-3.18-1.66l-.54-10.89c0-.93-1.16.2-1.87.8-2.22,1.92-7.59,4.07-10.85,2.93,0,0-9.78-3-12.13-9.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M82.06,215.87l2.76-1.42-1.57,24.3a1.5,1.5,0,0,1-.48,1,2,2,0,0,1-1,.52c-.69.11-1.29-.63-1.23-1.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M62.14,205.66l2.69-1.42L63,226.62a1.6,1.6,0,0,1-.49,1.06,2.18,2.18,0,0,1-.79.46c-.76.22-1.45-.61-1.37-1.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M99,210.54l3.2,19.5a1.25,1.25,0,0,1-.91,1.51c-.43.12-.86-.25-1-.83l-3.87-19.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M76.8,158.62c1.82-.3,2.86-.65,4.62-.13,3,.88,4.53,3.69,5.25,6.5s.93,7-.69,9.59c-1,1.64-3.27,1.34-4.89.91A18.92,18.92,0,0,1,75,172.92c-2.23-1.68-3.41-5.37-3.55-8C71.34,162.6,74,159.08,76.8,158.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-20",
  d: "M75.3,158.65c1.65-.84,4.36-.68,6.12-.16,2.8.83,4.34,3.44,5.11,6a8.47,8.47,0,0,1-3.77.68,3.44,3.44,0,0,0,0,2.35,1.47,1.47,0,0,1-1,2s-.67-1.92-1.66-1.38-.27,3.64.66,4.18c0,0-.68,2.49-1.13,2.7A15.9,15.9,0,0,1,75,172.92c-2.23-1.68-3.41-5.37-3.55-8C71.34,162.6,73.34,159.66,75.3,158.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M74.24,172.23a5.51,5.51,0,0,0,.76.69,18.92,18.92,0,0,0,6.09,2.57c.31.08.65.15,1,.21l-.24,1.06a15.32,15.32,0,0,1-5.67.34,2.21,2.21,0,0,1-2-2.2v-2.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-31",
  d: "M84.32,179.05s4.39-.12,5.48,2.95,3.55,9.21,3.55,9.21,3.73-2.89,5.11-3.25c0,0,3.07,1.56,3.79,3.25,0,0-4.63,8-10.29,10.35a39.69,39.69,0,0,1-9.1-14S79.21,181.52,84.32,179.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M63.18,181.63c11.5,2.39,17.34,8.52,19.18,10.83a3,3,0,0,1,.66,1.9v22.1c-15.41-2.57-22-11.63-22-11.63V183.37A1.78,1.78,0,0,1,63.18,181.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M83,216.46s13.28-1.33,17.37-5.92c0,0,.3-3.09-1-2.67A48.38,48.38,0,0,1,83,212.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M175.46,238.74a8.28,8.28,0,0,1,1.85-.22c.68,0,1.14.87,1.69,1.18a3.4,3.4,0,0,1,1.49,2.58c0,1.19-.53,2.49-1.18,2.49s-.8.13-1-.36a23,23,0,0,0-1.34-2.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M166.7,259.59a7.79,7.79,0,0,0,3.51-.72c1.12-.76,3.77,2.41,1.16,4.1s-5.29,3.36-6.7,3.12-2.16-.48-2.28-.8-.16-5.94-.16-5.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M167.69,255.36v6.41s-3.62,1.58-6,.66l-.9-4.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M177,263.27a7.81,7.81,0,0,0,3.51-.72c1.12-.76,3.77,2.42,1.16,4.1s-5.29,3.36-6.7,3.12-2.16-.48-2.29-.8-.16-5.94-.16-5.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M142.43,217.12a3.57,3.57,0,0,1,3.71-1l2.8.83,7.62,3.55,3.45,1.95,2.27,17.67.54,8.24L159.69,251c-3.73,3.49-15.17-2.65-15.17-2.65-1.92-6.38-4.75-23.95-4.75-23.95A11.11,11.11,0,0,1,142.43,217.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M161.55,244s8.81-1.69,13.7-2.12a3.12,3.12,0,0,1,3.41,3,173,173,0,0,1-1,19.61l-3,1.85a2.08,2.08,0,0,1-3.18-1.66l-.54-10.9c-.05-.93-1.16.2-1.86.81-2.23,1.91-7.59,4.06-10.85,2.92,0,0-9.79-3-12.14-9.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M156.77,259.6l2.76-1.43L158,282.48a1.53,1.53,0,0,1-.47,1,2.15,2.15,0,0,1-1,.51c-.7.11-1.3-.63-1.24-1.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M136.84,249.39l2.69-1.43-1.79,22.39a1.57,1.57,0,0,1-.48,1,2.15,2.15,0,0,1-.8.46c-.75.22-1.45-.61-1.36-1.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-16",
  d: "M173.74,254.26l3.2,19.5a1.36,1.36,0,0,1-.32,1.17,1.5,1.5,0,0,1-.59.35c-.44.12-.86-.26-1-.84l-3.87-19.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M151.51,202.34c1.82-.29,2.85-.64,4.61-.12,3,.87,4.54,3.68,5.25,6.49s.93,7-.69,9.59c-1,1.65-3.27,1.34-4.88.91a19.07,19.07,0,0,1-6.1-2.57c-2.23-1.68-3.41-5.36-3.54-8C146,206.32,148.73,202.8,151.51,202.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M148.94,216a5.45,5.45,0,0,0,.76.69,19.07,19.07,0,0,0,6.1,2.57c.31.08.65.15,1,.22l-.23,1.06c-2.08.57-3.62-.31-5.1-.48-1.11-.12-2.2-.39-2.52-1.38V216Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M137.88,225.35c11.51,2.39,17.34,8.53,19.18,10.83a3,3,0,0,1,.66,1.91v22.09c-15.4-2.56-22-11.63-22-11.63V227.1A1.78,1.78,0,0,1,137.88,225.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M157.72,260.18s13.28-1.32,17.37-5.92c0,0,.3-3.08-1-2.66s-7.26,4.09-16.41,5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-29",
  d: "M162.82,202a3.29,3.29,0,0,1-4.74,0c-2.6-2.29-12.83-1.6-12.26,7.8l1.23,3h0a8.69,8.69,0,0,0,2.65,3.89,15.92,15.92,0,0,0,4.67,2.16c.45-.22,1.14-2.71,1.14-2.71-.94-.54-1.66-3.64-.66-4.18s1.65,1.39,1.65,1.39a1.48,1.48,0,0,0,1-2,3.44,3.44,0,0,1,0-2.35,8.3,8.3,0,0,0,3.77-.68A6,6,0,0,0,162.82,202Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M148.78,216.73s1.92,2.67,7.93,3.06l.93,1.26s-5.18-.15-7-.85c-1.64-.64-2.08-1.18-2.11-2.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M174.72,238.38l1.34-.28a10,10,0,0,1,1.16,4.27l-1.19.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-32",
  d: "M175.12,238.16c-1.38.36-9.07.92-9.07.92s-.93-9.78-2-12.84a6.17,6.17,0,0,0-4-3.8c-5.12,2.47-2.45,8.86-2.45,8.86a76.32,76.32,0,0,1,3.36,12.49,2,2,0,0,0,2.28,1.62c6.81-1.11,13.22-2.66,13.22-2.66A8.7,8.7,0,0,0,175.12,238.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M270.37,128.6c11.4,0,20.65,2.81,20.65,6.28s-9.25,6.29-20.65,6.29-20.64-2.81-20.64-6.29S259,128.6,270.37,128.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M249.42,86a2.12,2.12,0,0,0,.16-.76c0-.29-.23-.09-.38.08-.4.47-.68,1-1.1,1.5-.12.14-.44.33-.46,0a5.13,5.13,0,0,1,.91-2.62,13,13,0,0,1,1-1.55c.19-.27.39-.52.6-.77s.45-.39.48-.58a2.28,2.28,0,0,0,0-.26l3.82.46a8.71,8.71,0,0,1,.14,1.62,5.49,5.49,0,0,1-.73,3,4.63,4.63,0,0,0-.29,2.1c0,.76.49,1.26.17,2s-2.44.91-3.67-.23a3.25,3.25,0,0,1-.83-2.38,5.75,5.75,0,0,1,.1-1.31A2.34,2.34,0,0,1,249.42,86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M250.25,79.91,250,81.34a10.24,10.24,0,0,0,5,.94l.39-1.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-24",
  d: "M254.46,46.81S252.65,66,250,80.24a8.06,8.06,0,0,0,5.39,1l2.94-15.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M279.21,76.37a1.72,1.72,0,0,0-1.08,1.12c-.4,1-1.7,2.58-2.15,2.33s0-4.31,0-4.31l.78-1.75Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "280.27 76.24 279.48 77.27 275.99 73.63 276.99 72.48 280.27 76.24"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M282.67,126.88s.26,3.11,1.62,4.21c3.33,2.69,4.8,5.24,1.84,6.13s-9.13-2.48-9.72-4.76l.43-6.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M258.48,126.88s-.26,3.11-1.63,4.21c-3.33,2.69-4.8,5.24-1.84,6.13s9.14-2.48,9.73-4.76l-.44-6.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M256,75.83v53.7s5.18,2,9.47-.66c0,0-.22-25.63.66-38.95,0,0,.66-.88,1.16.71,0,0,6.29,26.24,7.9,38.72,0,0,5,1.17,8.95-1.18,0,0-4-22.89-4.4-25.83S276,77.15,276,77.15,261.92,73.92,256,75.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M273.94,36.81l-1.56.41-.18,2.53C274.23,39.88,273.94,36.81,273.94,36.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M260,36.81l1.57.41.18,2.53C259.73,39.88,260,36.81,260,36.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-33",
  d: "M262.25,42.76s3.21-1.06,9.33-.09l-.51,1.48-6.88,1.39-1.67-1.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-25",
  d: "M271.44,43.64s8,1.69,8.83,2.57-1.18,12.84-2.06,15.41S276,77.15,276,77.15s-9,3.85-19.94-1.32c0,0-.52-9.32-1-14.2-.41-4.31-.58-14.82-.58-14.82A16.89,16.89,0,0,1,262.29,44,54.07,54.07,0,0,1,271.44,43.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-25",
  d: "M280.27,46.21S288.6,59,291,65.35L280.26,76.7l-3.67-4,7.18-7.27-4.09-7.21L274.4,51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-17",
  d: "M271.26,37.62,270.91,44s-3,2.92-8.07,0V37.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M273,35.18c0,4.62-2.71,8.36-6,8.36s-6-3.74-6-8.36,2.7-8.36,6-8.36S273,30.56,273,35.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-20",
  d: "M266.68,32.86s4.65-2.27,4.86,4.75a3.34,3.34,0,0,0,2.79-.47s2.26-12.25-7.59-11.1c0,0-8.44-.77-7.18,11.31a3.92,3.92,0,0,0,3.11.16S262.07,32,266.68,32.86Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-17",
  points: "262.95 44.1 266.96 47.24 270.12 44.94 269.7 44.19 262.95 44.1"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-18",
  points: "271.58 42.67 266.96 47.24 270.44 49.43 272.13 43.79 271.58 42.67"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-18",
  points: "262.25 42.77 266.96 47.24 263.49 49.43 261.41 44.03 262.25 42.77"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M255.71,69.76q0,.55.06,1.08a42.35,42.35,0,0,0,20.7,1l.12-1.13C265.25,72.61,258.53,70.86,255.71,69.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-18",
  d: "M255.87,72.87c0,.39,0,.75,0,1.07a42.24,42.24,0,0,0,20.24,1c0-.35.07-.72.11-1.13C265.33,75.6,258.75,74,255.87,72.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M276.59,73.79a2.12,2.12,0,0,1,.32,1.18c-.32,1.87.18,2,.28,3a2.69,2.69,0,0,1-.45,1.72c-.21.33-.59.92-1.05.88-.95-.1-2-1.84-1.56-2.65a3.5,3.5,0,0,0,.34-2.11c-.12-.75.17-1,.78-1.42C275.36,74.32,276.48,73.62,276.59,73.79Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "114.72 64.22 121.09 60.53 121.09 92.72 114.72 96.41 114.72 64.22"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "123.78 59.02 130.16 55.33 130.16 87.51 123.78 91.2 123.78 59.02"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "132.85 53.81 139.23 50.12 139.23 82.3 132.85 85.99 132.85 53.81"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "141.92 48.6 148.3 44.91 148.3 77.1 141.92 80.79 141.92 48.6"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "191.13 7.58 191.13 9.59 173.1 20.02 173.1 18.02 191.13 7.58"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "191.13 13.45 173.1 23.88 173.1 21.87 191.13 11.44 191.13 13.45"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "191.13 17.3 173.1 27.74 173.1 25.73 191.13 15.3 191.13 17.3"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "191.13 21.16 173.1 31.59 173.1 29.58 191.13 19.15 191.13 21.16"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "191.13 27.74 191.13 29.75 173.1 40.18 173.1 38.17 191.13 27.74"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "191.13 33.6 173.1 44.03 173.1 42.02 191.13 31.59 191.13 33.6"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "191.13 37.46 173.1 47.89 173.1 45.88 191.13 35.45 191.13 37.46"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "191.13 41.31 173.1 51.74 173.1 49.74 191.13 39.3 191.13 41.31"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "22.71 134.3 22.71 136.31 4.68 146.74 4.68 144.74 22.71 134.3"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "22.71 140.17 4.68 150.6 4.68 148.59 22.71 138.16 22.71 140.17"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "22.71 144.02 4.68 154.45 4.68 152.44 22.71 142.01 22.71 144.02"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "22.71 147.88 4.68 158.31 4.68 156.3 22.71 145.87 22.71 147.88"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "22.71 152.75 22.71 154.76 4.68 165.19 4.68 163.18 22.71 152.75"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "22.71 158.62 4.68 169.05 4.68 167.04 22.71 156.61 22.71 158.62"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "22.71 162.47 4.68 172.9 4.68 170.89 22.71 160.46 22.71 162.47"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "22.71 166.33 4.68 176.76 4.68 174.75 22.71 164.32 22.71 166.33"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-8",
  points: "3.02 186.68 3.02 190.3 82.44 144.36 82.44 140.73 3.02 186.68"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M66.45,114.92c-6.08,3.51-11,12-11,19s5,9.8,11,6.29,11-12,11-19S72.53,111.41,66.45,114.92Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-34",
  points: "295.87 23.77 380.98 128.06 380.98 73 295.87 23.77"
}))));

var SvgLayer1 = function SvgLayer1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 389.53 335.56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLayer1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Layer1.0e9e6335.svg";
export { ForwardRef as ReactComponent };